<template>
  <el-dialog
    :title="documentConfigName"
    :visible="visible"
    :close-on-click-modal="false"
    append-to-body
    class="process-records-dialog"
    :before-close="cancel"
    width="1000px"
  >
    <div style="height: 690px;" class="row">
      <div class="column" style="width: 72%;">
        <div class="upper">
          <div style="margin-top: 10px;">
            <el-row>
              <el-col :span="20">
                <h2 style="margin-left: 30px;color: #1e74d5;">{{ processTitle }}</h2>
              </el-col>
              <el-col :span="4">
                <el-button v-show="false" type="danger" @click="toTerminateTheProcess">{{ $t('CargoMsg.Cargo_TerminateTheProcess') }}</el-button>
              </el-col>
            </el-row>
          </div>
        </div>
        <div class="lower" style="border-right: 1px solid #E3E3E3;overflow: auto">
          <div class="card-container" style="margin-top: 10px">
            <div v-for="(nodes, index) in processNodes" :key="index">
              <div :key="index" class="tab-guide-wrapper" style="display: flex" :class="{flexend: !nodes.isOdd}">
                <div v-for="(processNode, nodeIndex) in nodes.data" :key="nodeIndex" :style="((nodes.isOdd && nodeIndex === 2) || (!nodes.isOdd && nodeIndex === 0)) ? 'display: grid' : 'display: flex'">
                  <div v-if="(!nodes.isOdd && nodeIndex > 0)" style="margin-top: 30%">
                    <div v-if="!nodes.isOdd && nodeIndex !== 0"><span class="my-arrow">←</span></div>
                  </div>
                  <div :class="'record-card ' + processNode.color">
                    <div style="margin: 2px">
                      <h2>{{ processNode.node.name }}</h2>
                    </div>
                    <div v-if="processNode.showContentList && processNode.showContentList.length === 1" class="one-center">
                      <span class="one-person">{{ processNode.showContentList[0] }}</span>
                    </div>
                    <div v-else>
                      <div style="margin: 10px;line-height: 21px;">
                        <el-row>
                          <el-col v-for="(contentText, userIndex) in processNode.showContentList" :key="userIndex" :span="12">
                            <span class="more-person">
                              {{ contentText }}
                            </span>
                          </el-col>
                        </el-row>
                      </div>
                    </div>
                  </div>
                  <div v-if="(nodes.isOdd && nodeIndex < nodes.data.length - 1) || (!nodes.isOdd && nodeIndex > 0)" style="margin-top: 30%">
                    <div v-if="nodes.isOdd"><span class="my-arrow">→</span></div>
                  </div>
                  <div v-if="((nodes.isOdd && nodeIndex === 2) || (!nodes.isOdd && nodeIndex === 0)) && index !== processNodes.length - 1" style="margin-left: 50%;">
                    <div><span class="my-arrow">↓</span></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="app-main-content column" style="width: 28%;border-left: 1px solid #E3E3E3;">
        <div class="tabs-container section">
          <!-- Right tabs -->
          <el-tabs v-model="activeTab" style="width: 100%">
            <el-tab-pane :label="$t('CargoMsg.Cargo_ApprovalRecord')" name="record">
              <div style="overflow-y: auto;">
                <div v-for="(card, index) in records" :key="index">
                  <el-card class="box-card">
                    <div>
                      <div>
                        <h2>{{ card.processNode.name }}</h2>
                      </div>
                      <div style="margin-top: 12px; margin-bottom: 12px;" :title="recordContentTitle(card)" :class="colorStyle(card.actionType)">
                        {{ recordContentLabel(card) }}
                      </div>
                      <div style="margin-bottom: 12px;" :title="copyLabel(card)">
                        {{ copyLabel(card, 3) }}
                      </div>
                      <div style="margin-bottom: 12px;">
                        {{ getRemark(card.remark) }}
                      </div>
                      <div>
                        {{ card.createTime }}
                      </div>
                      <div v-if="card.files && card.files.length > 0" style="margin-top: 10px;cursor: pointer;">
                        <div v-for="(file, index) in card.files" :key="index" class="file-style">
                          <div style="margin: 2px;display: flex;" @click="downloadFile(file.fileId)">
                            <i style="color: #1e74d5;" class="el-icon-paperclip" />
                            <span class="file-name">{{ file.fileName }}</span>
                            <span style="color: darkgray;">{{ WorkflowUtil.fileSizeLabel(file.fileSize) }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </el-card>
                  <div v-if="index < records.length - 1">
                    <span style="margin-left: 50%;">|</span>
                  </div>
                </div>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { WorkflowUtil } from '@/class/cargo/model/utils/WorkflowUtil'
import { cache, cacheName } from '@/utils/cacheManager'
import * as WorkflowConstants from '@/class/cargo/model/parameters/WorkflowConstants'
import URL from '@/api/urlTranslator'

export default {
  name: 'ProcessRecords',
  props: {
    title: { type: String, default: () => '' },
    type: { type: String, default: () => '' }, // apply-申请，look-查看，approve-审批
    workflowName: { type: String, default: () => '' },
    documentConfigName: { type: String, default: () => '' },
    processDetail: { type: Object, default: () => {} },
    records: { type: Array, default: () => [] }, // apply-申请，look-查看，approve-审批
    visible: { type: Boolean, default: () => false }
  },
  data() {
    return {
      WorkflowUtil: WorkflowUtil,
      activeTab: 'record',
      ColumnUtils: ColumnUtils,
      TYPE_NAMES: TYPE_NAMES,
      storageURL: ''
    }
  },
  computed: {
    processTitle() {
      if (!this.processDetail) {
        return ''
      }
      const userName = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', this.processDetail.creatorId, 'chineseName')
      return userName + '·' + this.processDetail.workflowGroup.name
    },
    processNodes() {
      if (!this.processDetail) {
        return []
      }
      return this.handleRowData(this.processDetail.nodeAttachInfoList, 3)
    }
  },
  async created() {
    await cache.load(cacheName.CONFIG)
    this.storageURL = cache.config.get('StorageURL')
  },
  methods: {
    // 终止流程
    toTerminateTheProcess() {
    },
    cancel() {
      this.$emit('close')
    },
    recordContentLabel(record) {
      const userName = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', record.userId, 'chineseName')
      // 7000:提交, 7001:同意, 7002:拒绝; 7003:审核撤回, 7004:流程撤销, 7006:退回发起节点; 7007:自动同意; 7008:催办; 7011:加签; 7012:转签; 7013:委派; 7014:取消加签
      const actionName = WorkflowUtil.getActionName(record.actionType)
      if (record.actionType === 7000) {
        return userName + ' ' + actionName + ' ' + this.documentConfigName
      }
      if ([7011, 7012, 7013, 7014].indexOf(record.actionType) !== -1) {
        let userList = record.effectUserId.split(',')
        userList = userList.slice(0, userList.len > 3 ? 3 : userList.len)
        return userName + ' ' + actionName + ' ' + ColumnUtils.resolveMultipleColumnLabel(TYPE_NAMES.basic_data_User, 'userId', userList, 'chineseName')
      }
      return userName + ' ' + actionName
    },
    recordContentTitle(record) {
      if ([7011, 7012, 7013, 7014].indexOf(record.actionType) !== -1) {
        const userList = record.effectUserId.split(',')
        return ColumnUtils.resolveMultipleColumnLabel(TYPE_NAMES.basic_data_User, 'userId', userList, 'chineseName')
      }
      return null
    },
    copyLabel(record, showCount) {
      const userNames = ColumnUtils.resolveMultipleColumnLabel(TYPE_NAMES.basic_data_User, 'userId', record.copyUserIds, 'chineseName')
      if (showCount) {
        if (userNames === null || userNames === '') {
          return this.$t('CargoMsg.Cargo_CarbonCopy') + ': ' + this.$t('CargoMsg.Cargo_None')
        }
        const userNameList = userNames.split(',')
        console.info('userNameList.length:' + userNameList.length)
        console.info('showCount:' + showCount)
        if (userNameList.length > showCount) {
          return this.$t('CargoMsg.Cargo_CarbonCopy') + ': ' + userNameList.slice(0, showCount).join(',') + '...'
        }
        return this.$t('CargoMsg.Cargo_CarbonCopy') + ': ' + userNames
      }
      return userNames
    },
    getRemark(remark) {
      console.info(remark)
      return this.$t('CargoMsg.Cargo_Remarks') + ': ' + (remark === null || remark === '' ? this.$t('CargoMsg.Cargo_None') : remark)
    },
    colorStyle(actionType) {
      switch (actionType) {
        case 7000:
        case 7008:
          return 'default'
        case 7001:
        case 7007:
        case 7011:
        case 7012:
        case 7013:
        case 7014:
          return 'success'
        default:
          return 'stop'
      }
    },
    // 角色用户 操作人类型，0:角色;1:用户;2:上级领导;
    actorTypeLabel(nodeActorType, nodeActorId) {
    },
    downloadFile(fileId) {
      const url = `${URL.common.findByFileId}/${fileId}?sessionId=${this.$store.getters.token}`
      window.open(url)
    },
    handleRowData(data, len) {
      const dataLen = data.length
      if (dataLen === 0) {
        return []
      }
      // 处理流程显示数据及颜色
      this.handleProcessData(data)
      // 将数据转换分组
      const row = Math.ceil(dataLen / len)
      let rowData = {}
      const rowDatas = []
      for (let i = 1; i <= row; i++) {
        if (i % 2 === 0) {
          rowData = { data: data.slice((i - 1) * len, i * len).reverse(), isOdd: false }
        } else {
          rowData = { data: data.slice((i - 1) * len, i * len), isOdd: true }
        }
        rowDatas.push(rowData)
      }
      console.info(rowDatas)
      return rowDatas
    },
    handleProcessData(list) {
      for (const data of list) {
        const showContentList = []
        if (data.showUsers) { // 展示
          if (!data.userList || data.userList.length === 0) {
            continue
          }
          const userList = data.userList.filter(item => item.actionType !== 1)
          for (const user of userList) {
            const userName = this.userLabel(user.userId)
            // 待处理
            if (user.actionType === 0) {
              showContentList.push(userName + '(' + this.$t('CargoMsg.Cargo_Processing') + ')')
              data.color = 'warn'
              continue
            }
            if (user.actionType === 7000) {
              showContentList.push(userName)
              data.color = 'success'
              continue
            }
            // 处理同意的情况
            if (user.actionType === 7001) {
              showContentList.push(userName + '(' + this.$t('CargoMsg.Cargo_Agreed') + ')')
              if (!data.color) { // 防止成功覆盖别的状态
                data.color = 'success'
              }
              continue
            }
            // 处理自动同意的情况
            if (user.actionType === 7007) {
              showContentList.push(userName + '(' + this.$t('CargoMsg.Cargo_AutoAgree') + ')')
              if (!data.color) { // 防止成功覆盖别的状态
                data.color = 'success'
              }
              continue
            }
            // 处理拒绝的情况
            if (user.actionType === 7002) {
              showContentList.push(userName + '(' + this.$t('CargoMsg.Cargo_Denied') + ')')
              data.color = 'danger'
              continue
            }
            // 处理撤回的情况
            if (user.actionType === 7003) {
              showContentList.push(userName + '(' + this.$t('CargoMsg.Cargo_AlreadyWithdraw') + ')')
              data.color = 'danger'
              continue
            }
            // 处理撤销的情况
            if (user.actionType === 7004) {
              showContentList.push(userName + '(' + this.$t('CargoMsg.Cargo_Revoked') + ')')
              data.color = 'danger'
              continue
            }
            // 处理退回的情况
            if (user.actionType === 7006) {
              showContentList.push(userName + '(' + this.$t('CargoMsg.Cargo_Returned2') + ')')
              data.color = 'danger'
              break
            }
          }
          data.showContentList = showContentList
          continue
        }
        data.color = 'default'
        if (!data.actors || data.actors.length === 0) {
          data.showContentList = showContentList
          continue
        }
        for (const actor of data.actors) {
          const actionName = this.processDetail.runningState === -9 ? this.$t('CargoMsg.Cargo_NoHandlingRequired') : this.$t('CargoMsg.Cargo_Pending')
          // 如果是用户
          if (actor.nodeActorType === 1) {
            const userName = this.userLabel(actor.nodeActorId)
            // 如果流程被撤销，则显示无需处理
            showContentList.push(userName + '(' + actionName + ')')
            continue
          }
          const auditName = this.auditName(actor.nodeActorType)
          showContentList.push(auditName + '(' + actionName + ')')
        }
        data.showContentList = showContentList
      }
    },
    userLabel(userId) {
      return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', userId, 'chineseName')
    },
    auditName(nodeActorType) {
      const common = WorkflowConstants.getCommonState(nodeActorType, WorkflowConstants.ACTOR_TYPES)
      return this.isZh ? common.chineseName : common.englishName
    },
    showProcessNodeColor(color) {
      return 'record-card' + color
    }
  }
}
</script>

<style lang="scss">
  .process-records-dialog{
    .el-tabs__active-bar{
      background-color: #7a39cf !important;;
      width: 135px !important;
    }
    .el-tabs__item{
      margin-left: 40px !important;;
      color: #7a39cf !important;;
    }
    .box-card{
      margin-left: 5px;
      margin-right: 5px;
    }
    .el-card__body{
      padding: 12px;
    }
    .file-style{
      margin-top: 2px;
      width: 210px;
      height: 15px;
      background: linear-gradient(135deg,#f7faff, #ffffff);
      border-radius: 2px;
    }
    .card-container{
      width: 675px;
      .success{
        background: #67c23a;
        h2{
          color: #ffffff;
        }
        .more-person {
          color: #ffffff;
        }
      }
      .danger{
        background: #F56C6C;
        h2{
          color: #ffffff;
        }
        .more-person {
          color: #ffffff;
        }
      }
      .warn{
        background: #E6A23C;
        h2{
          color: #ffffff;
        }
        .more-person {
          color: #ffffff;
        }
      }
      .default{
        h2{
          color: #333333;
        }
        .one-person{
          color: #67c23a;
        }
        .more-person {
          color: #67c23a;
        }
      }
    }
    .tabs-container {
      .success{
        color: #8DCE64;
      }
      .stop{
        color: red;
      }
    }
      /* Create two equal columns that floats next to each other */
    .column {
      float: left;
      height: 100%;
    }

    /* Clear floats after the columns */
    .row:after {
      content: "";
      display: table;
      clear: both;
    }

    /* Style the upper part */
    .upper {
      height: 8%;
      border-top: 1px solid #E3E3E3;
      border-bottom: 1px solid #E3E3E3;
    }

    /* Style the lower part */
    .lower {
      height: 92%;
    }
    .record-card{
      overflow-y: auto;
      margin: 1.7px;
      width: 206px; height: 160px;
      border-radius: 4px;
      box-shadow: 0px 0px 8px 0px rgba(218,218,218,0.50);
      h2{
        width: 170px;
        margin-left: 10px;
        height: 24px;
        font-size: 12px;
        font-family: PingFangSC, PingFangSC-Medium;
        font-weight: 500;
        line-height: 17px;
      }
    }
    .my-arrow{
      font-size: x-large;
    }
    /* 设置箭头容器样式 */
    .arrow-container {
      width: 100px; /* 宽度减半 */
      height: 10px; /* 高度减半 */
      top: 50%;
      bottom: 50%;
      position: relative;
    }

    /* 设置箭头线条样式 */
    .arrow-line {
      width: 90px;
      height: 1px; /* 高度减半 */
      background-color: #909399;
      margin-top: auto;
      margin-bottom: auto;
      position: absolute;
      top:0;
      bottom:0;
    }

    /* 设置箭头尖端样式 */
    .arrow-head {
      width: 0;
      height: 0;
      border-top: 5px solid transparent; /* 上边框宽度减半 */
      border-bottom: 5px solid transparent; /* 下边框宽度减半 */
      border-left: 10px solid #909399; /* 左边框宽度减半 */
      position: absolute;
      right:-1px;
    }

    /* 设置上半部分小三角形样式 */
    .arrow-head::before {
      content:"";
      width :0 ;
      height :0 ;
      border-top:none;
      border-left:none;
      border-right:none;
      border-bottom-width :1px ;/* 下 边 框 宽 度 减 半*/
      position:absolute;/* 绝 对 定位*/
      left:-9.5 px ;/* 左 移9.5像素*/
      top:-1 px ;/* 上 移1像素*/
    }

    /* 设置下半部分小三角形样式 */
    .arrow-head::after {
      content:"";
      width :0 ;
      height :0 ;
      border-bottom:none;/* 去 掉下 边 框*/
      border-left:none;/* 去 掉左 边 框*/
      border-right:none;/* 去 掉右 边 框*/
      border-top-width :1px ;/* 上 边 框 宽 度 减 半*/
      position:absolute;/* 绝 对 定位*/
      left:-9.5 px ;/* 左 移9.5像素*/
      bottom :-1 px ;/* 下 移1像素*/
    }
    .flexend {
      justify-content: flex-end;
      margin-right: 0px;
    }

    .file-name{
      color: #1e74d5;
      width: 60%;
      display: block;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .one-person{
      width: 125px;
      height: 30px;
      font-size: 22px;
      font-family: PingFangSC, PingFangSC-Medium;
      font-weight: 500;
      text-align: center;
      color: #ffffff;
      line-height: 30px;
    }
    .one-center{
      width: 190px;
      height: 70px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

</style>
